import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { openAddPrivilegeModal } from "../../Store/Slices/privilegeSlice";
import PrivilegeDialog from "../../Components/Privilege/PrivilegeDialog";
import PrivilegeTable from "../../Components/Privilege/PrivilegeTable";
import SearchBar from "../../Components/Shared/SearchBar";
import { Button, Container, Typography, Toolbar } from "@mui/material";
import { useGetAllPrivilegesQuery } from "../../Store/Services/privilegeService";
import styles from "./Management.module.css";

const PrivilegeManagement = () => {
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState([]);
  const [roles, setRoles] = useState("");

  useEffect(() => {
    const getRoles = () => {
      if (typeof window !== undefined) {
        setRoles(sessionStorage.getItem("role"));
      }
    };
    getRoles();
  }, []);

  const { data: privilege, isSuccess, isLoading } = useGetAllPrivilegesQuery();

  return (
    <>
      {roles?.split(",").includes("PRIV_ECOM_PRIVILEGEDISPLAY") && (
        <div className={styles.pageContainer}>
          <div>
            <Toolbar className={styles.subNavBar}>
              <Typography className={styles.topic}>
                {" "}
                Privilege Management
              </Typography>

              {roles?.split(",").includes("PRIV_ECOM_ADDPRIVILEGE") && (
                <Button
                  onClick={() => dispatch(openAddPrivilegeModal())}
                  variant="contained"
                  color="primary"
                  className={styles.buttonItem}
                  aria-label="Add New Role"
                >
                  Add New
                </Button>
              )}
            </Toolbar>
          </div>

          <Container>
            {isSuccess && (
              <SearchBar
                data={privilege || []}
                setSearchData={setSearchData}
                text="Search Privilege"
                search="privilege"
              />
            )}
          </Container>

          <Container>
            <PrivilegeTable data={searchData} />
          </Container>

          <PrivilegeDialog />
        </div>
      )}
    </>
  );
};

export default PrivilegeManagement;
